import { render, staticRenderFns } from "./wx-link.vue?vue&type=template&id=33ea8c2a&scoped=true&"
import script from "./wx-link.vue?vue&type=script&lang=js&"
export * from "./wx-link.vue?vue&type=script&lang=js&"
import style0 from "./wx-link.vue?vue&type=style&index=0&id=33ea8c2a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea8c2a",
  null
  
)

export default component.exports